<scanshop-shell>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</scanshop-shell>
